import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareBoardViewNotFoundClassicRoute: InvariantJiraRoute = {
	name: 'software-board-view-not-found-classic',
	exact: true,
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/not-found',
};
